<template>
  <div class="content">
    <div v-if="!isSupplier">
      <van-icon name="cart-circle-o" color="#E1514C" size="2.8rem" @click="jump(1)" />
      <div class="describe">配货申请</div>
    </div>
    <div>
      <van-icon name="orders-o" color="#E1514C" size="2.8rem" @click="jump(2)" />
      <div class="describe">申请记录</div>
    </div>
    <div>
      <van-icon name="contact" color="#E1514C" size="2.8rem" @click="jump(3)" />
      <div class="describe">审批</div>
      <div class="number" v-if="approveNumber">{{ approveNumber }}</div>
    </div>
    <div v-if="isOpen">
      <van-icon  name="bag-o" color="#E1514C" size="2.8rem" @click="jump(4)" />
      <div class="describe">销售包管理</div>
    </div>
    <div v-if="isOpen">
      <van-icon name="bag-o" color="#E1514C" size="2.8rem" @click="jump(5)" />
      <div class="describe">销售车管理</div>
    </div>
    <div v-if="!isOpen">
      <van-icon name="bag-o" color="#E1514C" size="2.8rem" @click="jump(6)" />
      <div class="describe">销售包管理(旧)</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '机上销售',
    },
  },
  data() {
    return {
      approveNumber: 0,
      isSupplier: localStorage.getItem('is_supplier') === '1',
      isOpen: false,
    }
  },
  activated() {
    this.getIsOpen();
    this.$EventBus.$emit('setPageName', 'Content')
    this.$EventBus.$emit('setShowHome', true)
    if (this.isSupplier) {
      this.getSupplierApproveCount()
    } else {
      this.getApproveCount()
    }
  },
  methods: {
    retFunt() {
      window.history.back()
    },
    jump(type) {
      switch (type) {
        case 1:
          this.$utils.routerPush('/mobile/DistributionApplication')
          break
        case 2:
          this.$utils.routerPush(`/mobile/${this.isSupplier ? 'ApplicationRecordSupply' : 'ApplicationRecord'}`)
          break
        case 3:
          this.$utils.routerPush(`/mobile/${this.isSupplier ? 'DistributionApprovalSupply' : 'DistributionApproval'}`)
          break
        case 4:
          this.$utils.routerPush(this.isSupplier ? '/mobile/OvernightBagManage' : '/mobile/OvernightBagAll')
          // this.$utils.routerPush('/mobile/OvernightBagAll')
          break
        case 5:
          this.$utils.routerPush(this.isSupplier ? '/mobile/OvernightCarManage' : '/mobile/OvernightBagAll')
          // this.$utils.routerPush('/mobile/OvernightBagAll')
          break
        case 6:
          this.$utils.routerPush(this.isSupplier ? '/mobile/OvernightBagManageOld' : '/mobile/OvernightBagAll')
          // this.$utils.routerPush('/mobile/OvernightBagAll')
          break
        default:
          break
      }
    },
    // 获取当前 供应商 待审批数量
    getSupplierApproveCount() {
      let url = `/api-sys/sell/addMatterSearch/getSupplierApproveCount?supplierId=${this.$store.state.userInfo.vonderId}&companyId=${this.$store.state.userInfo.companyId}`
      this.$api.get(url).then((res) => {
        if (res.code === '0000') {
          this.approveNumber = res.data || 0
        }
      })
    },
    // 获取当前 高位 待审批数量
    getApproveCount() {
      let url = `/api-sys/sell/addMatterSearch/getApproveCount?staffId=${this.$store.state.userInfo.userId}&companyId=${this.$store.state.userInfo.companyId}`
      this.$api.get(url).then((res) => {
        if (res.code === '0000') {
          this.approveNumber = res.data || 0
        }
      })
    },
    getIsOpen() {
      this.$api.post('/api-sys/apiOverNightBag/isOpen').then((res) => {
        if (res.code === '0000') {
          this.isOpen = res.data
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  & > div {
    display: inline-block;
    padding-top: 2rem;
    width: 20%;
    height: 8rem;
    text-align: center;
    position: relative;
    .describe {
      font-size: 0.8rem;
      margin-top: 10px;
    }
    .number {
      height: 1rem;
      width: 1rem;
      line-height: 1rem;
      border-radius: 0.5rem;
      font-size: 0.8rem;
      font-weight: 600;
      color: white;
      background: #e1514c;
      position: absolute;
      top: 1.8rem;
      right: 1.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content.vue